

const loanTotals = {
    amount : function () {
        return currencyHelpers.fromElement(jQuery('input[name=LoanAmount]'));
    },
    haveADeposit : function() {
        let selectedValue = jQuery('input[name=HaveADeposit]:checked');
        return (selectedValue.length && selectedValue.val() === 'yes');
    },
    deposit : function() {
        if(loanTotals.haveADeposit()) {
            return currencyHelpers.fromElement(jQuery('input[name=DepositAmount]'));
        }
        return 0;
    },
    total : function() {
        return loanTotals.amount() - loanTotals.deposit();
    },
    toggleFields : function() {
        let selectedDeposit = jQuery('input[name=HaveADeposit]:checked');
        if(selectedDeposit.length) {
            jQuery('.show-if-deposit').toggleClass('d-none', !(selectedDeposit.val() === 'yes'));
            loanTotals.updateTotal();
        }
    },
    updateTotal : function() {
        let loanTotalElement = jQuery('.loan-amount-total');

        if(loanTotalElement.length) {
            loanTotalElement.text( currencyHelpers.toFormatted( loanTotals.total() ) );
            repaymentTermCalculator.calculatePayments();
        }

        preApproval.updateStatus();
    }
};


jQuery( document ).ready(function() {
    jQuery('input[name=LoanAmount]').on('keyup change blur keypress', loanTotals.updateTotal);
    jQuery('input[name=DepositAmount]').on('keyup change blur keypress', loanTotals.updateTotal);
    loanTotals.updateTotal();

    jQuery('input[name=HaveADeposit]').on('click change', loanTotals.toggleFields);
    loanTotals.toggleFields();
});